/**
 * Returns whether v matches AbsoluteFeatureTableAttributes
 * @param v
 */
export function isAbsoluteFeatureTableAttributes(v) {
    return typeof v.POSITION !== "undefined";
}
/**
 * Returns whether v matches QuantizedFeatureTableAttributes
 * @param v
 */
export function isQuantizedFeatureTableAttributes(v) {
    return typeof v.POSITION_QUANTIZED !== "undefined";
}
/**
 * Returns whether v matches AbsoluteFeatureTable
 * @param v
 */
export function isAbsoluteFeatureTable(v) {
    return isAbsoluteFeatureTableAttributes(v.attributes);
}
/**
 * Returns whether v matches QuantizedFeatureTable
 * @param v
 */
export function isQuantizedFeatureTable(v) {
    return isQuantizedFeatureTableAttributes(v.attributes);
}
